import {useState, useEffect, useContext} from 'react';
import { Select, Carousel, Row, Col, Input} from 'antd';
import Utils from '@utils/utils'
import {AppContext} from '@utils/AppContext'
import API from '@api/api'
import styles from './softEdge.module.scss'
const { TextArea } = Input;

const SoftEdge = (props) => {
    const { setSoftEdgeList } = useContext(AppContext)
    const [position, setPosition] = useState(0);
    const [direction, setDirection] = useState('left');
    const [selected, setSelected] = useState(0);
    const [selectedImg, setSelectedImg] = useState();
    const [modelbgList, setModelbgList] = useState([]);
    const [group, setGroup] = useState();
    


    useEffect(() => {
        getShowcaseList(group)
    }, []);

    function getShowcaseList(group) {
        API.commodityShowcaseList({group: group}).then((res) => {
            if(res.code == 0) {
                setModelbgList(res.data)
                setSoftEdgeList(res.data)
            }
        }).catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        // console.log(direction)
    },[direction])
  
    const handleLeftClick = () => {
      if (direction === 'left') {
        return;
      }
      setPosition(position - 2.1);
      setDirection('left'); 
    };
  
    const handleRightClick = () => {
      if (direction === 'right') { 
        return;
      }
      setPosition(position + 2.1);
      setDirection('right'); 
    };

    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    const typeChange = (value) => {
        setGroup(value);
        getShowcaseList(value)
    };

    const selectImgClick = (imageUrl) => {
        props.getEdgeUrl(imageUrl)
    }
  
    return (
        <div className={styles.SelectScene}>
            {/* <div className={styles.change_bg}>
                <div className={styles.change_bg_child} style={{ left: `${position}rem` }}></div>
                <div className={styles.change_item} onClick={handleLeftClick}>预置素材库</div>
                <div className={styles.change_item}>个人素材库</div>
                <img src={require('@assets/images/look forward_level.png')} alt="" />
            </div> */}
            {/* <div className={styles.change_select}>
                <Select
                    style={{width: '100%'}}
                    onChange={typeChange}
                    defaultValue={''}
                    options={[{
                        value: '',
                        label: '全部',
                    },  {
                        value: 'plant',
                        label: '花草',
                    }, {
                        value: 'platform',
                        label: '展台',
                    }, {
                        value: 'hand',
                        label: '手模',
                    }]}
                />
            </div>  */}
            {
                direction == 'left'? 
                (<div className={styles.scene_select_img}>
                        {
                            <div className={`${styles.scene_select_img_box} ${styles.softedge_item}`}>
                                {
                                    modelbgList.map((item2, index) => {
                                        if(index > 4) return
                                        return <div onClick={() => selectImgClick(item2.imageUrl)} key={item2.name} className={styles.sceneItem} >
                                            <img  src={Utils.addVersionParamToURL(item2.imageUrl, 'v', item2?.attr?.version)} alt="" />
                                        </div>
                                    })
                                }
                                {
                                    modelbgList.length > 0 &&
                                    <div className={styles.moreItem} onClick={(e) => props.toggleDrawer(e, 'Softedge')}><p>更多 <i></i></p></div>
                                }
                            </div>
                        }
                    
                </div>): (<div className={styles.custom} >
                    <p className={styles.custom_p}>位置</p>
                    <Row>
                        <Col span={8}>
                            <Select
                                style={{width: '100%'}}
                                onChange={handleChange}
                                options={[
                                    {
                                        value: '时尚街道',
                                        label: '站在'
                                    },
                                ]}
                            />

                        </Col>
                        <Col span={16} style={{paddingLeft: '10px'}}>
                            <Select
                                style={{width: '100%'}}
                                onChange={handleChange}
                                options={[
                                    {
                                        value: '时尚街道',
                                        label: '一片青草地'
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                    <p className={styles.custom_p}>环境</p>
                    <TextArea rows={6} placeholder="请填写您想要的背景描述，如蓝天白云下的绿色草原" />
                </div>)
            }
            </div>
    )
}

export default SoftEdge